import React from 'react';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount, useDisconnect } from 'wagmi';

const ConnectWalletButton = ({ onConnect, onDisconnect }) => {
  const { openConnectModal } = useConnectModal();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  // Format address for display
  const formatAddress = (address) => {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  React.useEffect(() => {
    if (isConnected && address && onConnect) {
      onConnect(address);
    }
  }, [isConnected, address, onConnect]);

  const handleDisconnect = () => {
    disconnect();
    if (onDisconnect) {
      onDisconnect();
    }
  };

  if (isConnected && address) {
    return (
      <div className="wallet-info">
        <div className="address-display">
          Connected: {formatAddress(address)}
        </div>
        <button className="disconnect-wallet-btn" onClick={handleDisconnect}>
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <button className="connect-wallet-btn" onClick={openConnectModal}>
      Connect Wallet
    </button>
  );
};

export default ConnectWalletButton; 